import React, { createContext, ReactNode, useContext, useState } from "react";

//* Variables que maneja o interface que estipula la info que comparte
interface CorporateContextProps {
  corporateId?: number; // ID del grupo corporativo
  setCorporateId: (id: number | undefined) => void; // Funcion para cambiar el ID
  isExternal?: boolean; // Si es un usuario externo 
  setIsExternal: (status: boolean) => void; // Funcion para cambiar el estado externo
}


//* Crea el recipiente o caja (contexto) con un valor por defecto, donde se guardara la info
const CorporateContext = createContext<CorporateContextProps | undefined>(
  undefined
);

//* Crea un proveedor de contexto que se encargara de distribuir la info a todos los componentes hijos
export const CorporateProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [corporateId, setCorporateId] = useState<number | undefined>(undefined);
  const [isExternal, setIsExternal] = useState<boolean>(false);

  return (
    <CorporateContext.Provider
      value={{ corporateId, setCorporateId, isExternal, setIsExternal }}
    >
      {/* // los componentes children pueden acceder a la info del value */}
      {children} 
    </CorporateContext.Provider>
  );
};

//* Hook personalizado para usar el contexto de forma mas sencilla
export const useCorporate = () => {
  const context = useContext(CorporateContext);
  if (!context) {
    throw new Error("useCorporate debe usarse dentro de un CorporateProvider");
  }
  return context;
};
